import { render } from "./Assets.vue?vue&type=template&id=a073bdb2&scoped=true"
import script from "./Assets.vue?vue&type=script&lang=js"
export * from "./Assets.vue?vue&type=script&lang=js"

import "./Assets.vue?vue&type=style&index=0&id=a073bdb2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a073bdb2"]])

export default __exports__